import script from "./AppSnackbar.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppSnackbar.vue?vue&type=script&setup=true&lang=ts"

import "./AppSnackbar.vue?vue&type=style&index=0&id=7ab8505f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ab8505f"]])

export default __exports__